import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const User = (function() {
  function GetUser() {
    if (logComponent('User')) { console.debug('User GetUser'); }
    let config = getConfig();
    return axios.get('api/User', config);
  }

  function Id(userId) {
    if (logComponent('User')) { console.debug('User Id'); }
    return axios.get(`api/User/${userId}`, getConfig());
  }

  function GetUsersForCurrentUser(queryDetails) {
    if (logComponent('User')) { console.debug('User GetUsersForCurrentUser'); }
    let params = queryDetails;
    return axios.get('api/User/GetUsersForCurrentUser', getConfig( params));
  }

  function GetGroups(userId) {
    if (logComponent('User')) { console.debug('User GetGroups'); }
    const params = { userId };
    return axios.get('api/User/GetGroups', getConfig(params));
  }

  

  function GetFamilyRelationships(userId) {
    if (logComponent('User')) { console.debug('User GetFamilyRelationships'); }
    const params = { userId };
    return axios.get('api/User/GetFamilyRelationships', getConfig( params));
  }

  function GetManagedUsers() {
    if (logComponent('User')) { console.debug('User GetManagedUsers'); }
    return axios.get('api/User/GetManagedUsers', getConfig());
  }

  function EmailInUse(emailAddress) {
    if (logComponent('User')) { console.debug('User EmailInUse'); }
    const params = { emailAddress };
    return axios.get('api/User/EmailInUse', getConfig( params));
  }

  function AddOrUpdate(user) {
    if (logComponent('User')) { console.debug('User AddOrUpdate'); }
    return axios.put('api/User/AddOrUpdate', user, getConfig());
  }

  function UnsetUpdateForcePasswordChangeNextSignIn() {
    if (logComponent('User')) { console.debug('User UnsetUpdateForcePasswordChangeNextSignIn'); }
    return axios.post('api/User/UnsetUpdateForcePasswordChangeNextSignIn', null, getConfig());
  }

  /* TODO: Check capitalization here */
  function AddGroups(userId, groupIds) {
    if (logComponent('User')) { console.debug('User AddGroups'); }
    const data = { userId, groupIds };
    return axios.post('api/User/AddGroups', data, getConfig())
  }

  function RemoveGroups(userId, groupIds) {
    if (logComponent('User')) { console.debug('User RemoveGroups'); }
    const data = { userId, groupIds };
    return axios.delete('api/User/RemoveGroups', getConfig( null, data));
  }

  function Delete(user) {
    if (logComponent('User')) { console.debug('User Delete'); }
    return axios.delete('api.User/Delete', getConfig( null, user));
  }

  function AddUserSurveyTypes(userId, userSurveyTypeIds) {
    if (logComponent('User')) { console.debug('User AddUserSurveyTypes'); }
    const data = { userId, userSurveyTypeIds };
    return axios.post('api/User/AddUserSurveyTypes', data, getConfig())
  }

  function RemoveUserSurveyTypes(userId, userSurveyTypeIds) {
    if (logComponent('User')) { console.debug('User RemoveUserSurveyTypes'); }
    const data = { userId, userSurveyTypeIds };
    return axios.delete('api/User/RemoveUserSurveyTypes', getConfig(null, data));
  }

  function GetUserCheckInSurvey(userId) {
    if (logComponent('User')) { console.debug('User GetUserCheckInSurvey'); }
    const params = { userId };
    return axios.get('api/User/GetUserCheckInSurvey', getConfig(params));
  }

  return {
    get: GetUser,
    Id,
    GetUsersForCurrentUser,
    GetGroups,
    GetFamilyRelationships,
    GetManagedUsers,
    EmailInUse,
    AddOrUpdate,
    UnsetUpdateForcePasswordChangeNextSignIn,
    AddGroups,
    RemoveGroups,
    Delete,
    GetUserCheckInSurvey,
    AddUserSurveyTypes,
    RemoveUserSurveyTypes
  }
})();

export default User;